import { icons, IconText } from '../../../generic';
import type { Repository } from '../../../../types';

import ProjectRowBase from './ProjectRowBase';
import type { OnBranchChangeFn, OnImportRepositoryFn, OnSelectRepositoryFn } from './types';

import styles from './UnimportedProjectRow.module.less';

type UnimportedProjectRowProps = {
  repo: Repository;
  selectedRepos: Repository[];
  onBranchChange: OnBranchChangeFn;
  onSelectRepository: OnSelectRepositoryFn;
  onImportRepository: OnImportRepositoryFn;
};

const UnimportedProjectRow = ({
  repo,
  selectedRepos,
  onBranchChange,
  onSelectRepository,
  onImportRepository,
}: UnimportedProjectRowProps) => {
  const status = (
    <span className={styles.readyToImportFolder}>
      <IconText icon={icons.folderDown} text="Ready to import" marginAmount="8px" />
    </span>
  );

  return (
    <ProjectRowBase
      repo={repo}
      selectedRepos={selectedRepos}
      onBranchChange={onBranchChange}
      onSelectRepository={onSelectRepository}
      onImportRepository={onImportRepository}
      status={status}
    />
  );
};

export default UnimportedProjectRow;
